<template>
  <div v-if="isProfileHydrated && isLoggedInToSolCentreAsProvider" class="provider-home">
    <a-alert showIcon type="info" message="Please select a project to view the details." />
    <ProjectTable :showAdd="true" :showLaunch="true" :show-subscription-usage="false" />
  </div>
  <PerformanceTabConsumer
    v-else-if="isProfileHydrated && (!nativeEnabled || isLoggedInToSolCentreAsConsumer)"
  />
  <RouterLink v-else-if="isProfileHydrated && nativeEnabled" to="/commissioning/welcome"
    >Open commissioning</RouterLink
  >
</template>

<script>
import ProjectTable from '../components/ProjectTable.vue';
import PerformanceTabConsumer from '../components/Tabs/PerformanceTabConsumer.vue';
import { useAuthStore } from '@/shared/stores/authStore';
import { AppContext } from '@/models/AppContext';
import { UserRole } from '@/models/UserRole';
import { isNativeCognitoEnabled } from '@/shared/auth/cognitoFeatureFlag';

export default {
  components: { ProjectTable, PerformanceTabConsumer },
  computed: {
    nativeEnabled() {
      return isNativeCognitoEnabled;
    },
    isProfileHydrated() {
      return useAuthStore().isProfileHydrated;
    },
    isLoggedInToSolCentreAsProvider() {
      return (
        useAuthStore().isLoginAtAs(AppContext.SolCentre, UserRole.Provider) &&
        !(isNativeCognitoEnabled && this.isLoggedInToSolCentreAsConsumer)
      );
    },
    isLoggedInToSolCentreAsConsumer() {
      return useAuthStore().isLoginAtAs(AppContext.SolCentre, UserRole.Consumer);
    },
  },
};
</script>

<style lang="less" scoped>
.provider-home {
  .ant-alert-info {
    background-color: #e6f7ff;
    border: 1px solid #91d5ff;

    .ant-alert-icon {
      color: #1890ff;
    }
  }

  &__statistic-panel {
    display: flex;
    justify-content: space-between;
  }

  &__subtitle {
    margin: 2em 0 1em;
    color: #888;
  }
}
</style>
